import Scene from './Scene';
import common from '../common';
import commonGame from '../commonGame';

const _colourItClick = Symbol('_colourItClick');
const _drawItClick = Symbol('_drawItClick');
const _backClick = Symbol('_backClick');
const _createBackground = Symbol('_createBackground');
const _createButtons = Symbol('_createButtons');

export default class TypeSelectionScene extends Scene {
	constructor() {
		super();
		this._colourItBtn = null;
		this._drawItBtn = null;
		this._muteBtn = null;
		this._backBtn = null;

		this._colourItText = null;
		this._drawItText = null;

		this._colourItSprite = null;
		this._drawItSprite = null;

		this._themeSprite = null;
		this._themeText = null;
	}

	init() {
		super.init();
		this[_createBackground]();
		this[_createButtons]();
	}

	appear() {
		this.animateIn();
	}

	animateIn() {
		new P3.utils.TWEEN.Tween(this._muteBtn.scale, this.tweens)
			.to({
				x: 1, y: 1
			}, 340)
			.delay(200)
			.easing(P3.utils.Easing.Back2.Out)
			.onUpdate(()=> {
				this._backBtn.scale = this._muteBtn.scale;
			})
			.start();

		new P3.utils.TWEEN.Tween(this._drawItBtn.scale, this.tweens)
			.to({
				x: 1, y: 1
			}, 340)
			.delay(300)
			.onUpdate(()=> {
				this._colourItBtn.scale = this._drawItBtn.scale;
			})
			.easing(P3.utils.Easing.Back3.Out)
			.start();

		new P3.utils.TWEEN.Tween(this._colourItSprite, this.tweens)
		    .to({
		        x: '+100',
				alpha: 1
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
		    .start();

		new P3.utils.TWEEN.Tween(this._drawItSprite, this.tweens)
			.to({
				x: '-100',
				alpha: 1
			}, 250)
			.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
			.start();
	}

	destroy(options) {
		// clean up goes here
		super.destroy();
	}

	resize() {
		super.resize();
		this._muteBtn.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 70;
		this._backBtn.x = (common.STAGE_WIDTH - P3.View.width) * 0.5 + 70;
	}

	update() {
		super.update();
	}

	[_createBackground]() {
		const bgConfig = common.levelConfig.type_select.bg;

		for (const bgConfigElement of bgConfig)
			this.addChild(common.createSprite(bgConfigElement));

		//create title
		const titleConfig = common.levelConfig.type_select.title;
		// const titlebg = common.createSprite(titleConfig);
		// this.addChild(titlebg);
		//
		// const titleText = P3.createText('GAMES', {
		// 	size: '100px',
		// 	fill: 'white',
		// 	stroke: '#2c1812',
		// 	stokeThickness: 6,
		// 	wordWrap: true,
		// 	wordWrapWidth: 1000
		// }, 'truetype');
		// titleText.anchor = new PIXI.Point(0.5, 0.5);
		// titleText.y = -titleText.height * 0.5 - 50;
		// titlebg.addChild(titleText);

		//create colour_it
		const colourItConfig = common.levelConfig.type_select.colour_it;
		this._colourItSprite = common.createSprite(colourItConfig);
		this.addChild(this._colourItSprite);

		const colourItTextConf = {
			size: '60px',
			fill: '#3992ff',
			stroke: '#2c1812',
			wordWrapWidth: 400
		};
		const colourItText = P3.createMultiText('COLOUR_IT', colourItTextConf);

		colourItText.anchor = new PIXI.Point(0.5, 0.5);
		colourItText.y = -this._colourItSprite.height * 0.5 + 15;
		this._colourItSprite.addChild(colourItText);

		//create draw_it
		const drawItConfig = common.levelConfig.type_select.draw_it;
		this._drawItSprite = common.createSprite(drawItConfig);
		this.addChild(this._drawItSprite);

		const drawItText = P3.createText('DRAW_IT', {
			size: '55px',
			fill: 'white',
			stroke: '#2c1812',
			stokeThickness: 6,
			wordWrap: true,
			wordWrapWidth: 500
		}, 'truetype');

		drawItText.anchor = new PIXI.Point(0.5, 0.5);
		drawItText.y = -this._drawItSprite.height * 0.5 + 15;
		this._drawItSprite.addChild(drawItText);

		this._drawItSprite.y -= 100;
		this._drawItSprite.x += 100;
		this._drawItSprite.alpha = 0;
		this._colourItSprite.x -= 100;
		this._colourItSprite.y -= 100;
		this._colourItSprite.alpha = 0;
	}

	[_createButtons]() {
		this._backBtn = createButton('back');
		this._backBtn.anchor = new PIXI.Point(0.5, 0.5);
		this._backBtn.position = new PIXI.Point(
			(common.STAGE_WIDTH - P3.View.width) * 0.5 + 70,
			this._backBtn.height * 0.5 + 30
		);
		this._backBtn.overSoundName = 'sfx_ui_rollover_00';
		this._backBtn.downSoundName = 'sfx_btn_play_start_doorbell_00';
		this._backBtn.signals.click.once(this[_backClick], this);
		this._backBtn.scale.set(0);
		this.addChild(this._backBtn);

		const states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_primary_small_' + 'off');
		states.over = P3.assets.texture('btn_primary_small_' + 'over');
		states.down = P3.assets.texture('btn_primary_small_' + 'down');
		states.icon = P3.assets.texture('icon_sound');
		states.iconAlt = P3.assets.texture('icon_mute');

		this._muteBtn = new P3.MuteButton(states);

		this._muteBtn.position = new PIXI.Point(
			(common.STAGE_WIDTH + P3.View.width) * 0.5 - 70,
			this._muteBtn.height * 0.5 + 30
		);
		this._muteBtn.scale.set(0);
		this.addChild(this._muteBtn);

		this._colourItBtn = createButton('play', 'primary_large');
		this._colourItBtn.position = new PIXI.Point(
			this._colourItSprite.x + 100,
			this._colourItSprite.y + this._colourItSprite.height * 0.5
		);
		this._colourItBtn.overSoundName = 'sfx_ui_rollover_00';
		this._colourItBtn.downSoundName = 'sfx_btn_play_start_doorbell_00';
		this._colourItBtn.signals.click.once(this[_colourItClick], this);
		this._colourItBtn.scale.set(0);
		this.addChild(this._colourItBtn);

		this._drawItBtn = createButton('play', 'primary_large');
		this._drawItBtn.position = new PIXI.Point(
			this._drawItSprite.x - 100,
			this._drawItSprite.y + this._drawItSprite.height * 0.5
		);
		this._drawItBtn.overSoundName = 'sfx_ui_rollover_00';
		this._drawItBtn.downSoundName = 'sfx_btn_play_start_doorbell_00';
		this._drawItBtn.signals.click.once(this[_drawItClick], this);
		this._drawItBtn.scale.set(0);
		this.addChild(this._drawItBtn);
	}

	[_colourItClick]() {
		commonGame.selectedGallery = commonGame.GALLERY_ID_COLOUR_IT;
		this.signals.next.dispatch(this);
	}

	[_drawItClick]() {
		commonGame.selectedGallery = commonGame.GALLERY_ID_DRAW_IT;
		this.signals.next.dispatch(this);
	}

	[_backClick]() {
		this.signals.previous.dispatch();
	}
}
